import React,{useState,useEffect,useRef} from 'react';
import { useLocation } from "react-router-dom";
import { getTemproryTransferData, saveTemproryTransferData } from '../../../services/asset.service';
import FromFieldLabel from '../../../atoms/FromFieldLabel';
import FromFieldText from '../../../atoms/FromFieldText';
import FromFieldDate from '../../../atoms/FromFieldDate';
import FromFieldSelect from '../../../atoms/FromFieldSelect';

const TEXT_REGEX = /^[a-zA-Z0-9-_ ]{1,23}$/;
const NUMBER_REGEX = /^[0-9]{1,15}$/;
const getFormatedDate = function(dateString) {
    if(dateString!=null) {
        let dte = new Date(dateString);
        let year = dte.getFullYear();
        let month = dte.getMonth() + 1;
        let day = dte.getDate();
        if (month < 10) {
          month = '0' + month;
        }if (day < 10) {
          day = '0' + day;
        }
        return day + '-' + month + '-' + year;
        //return `${dte.getFullYear()}-${dte.getMonth()+1}-${dte.getDate()}`;
    } else {
        return null;
    }   
  }

function TemproryTransfer() {
    const [tag, setTag] = useState(0);
    const [ErrTAG, setErrTag] = useState(false);
    const [errMsg, setErrMsg] = useState('');
    const [success, setSuccess] = useState(false);
    const [validName, setValidName] = useState(true);


    const [assetInfo, setAssetInfo] = useState({
        "financials_classification": "",
        "invoice_date": "",
        "supplier_name": "",
        "invoice_no": ""
    });

    var transferId='';
    const [transferInitiatedBy, setTransferInitiatedBy] = useState('');
    const [ErrTransferInitiatedBy, setErrTransferInitiatedBy] = useState('');
    const [initiationDate, setInitiationDate] = useState('');
    const [ErrInitiationDate, setErrInitiationDate] = useState('');
    const [transferApprovedBy, setTransferApprovedBy] = useState('');
    const [ErrTransferApprovedBy, setErrTransferApprovedBy] = useState('');
    const [approvalDate, setApprovalDate] = useState('');
    const [ErrApprovalDate, setErrApprovalDate] = useState('');
    const [transferType, setTransferType] = useState('');
    const [ErrTransferType, setErrTransferType] = useState('');
    const [serviceProviderName, setServiceProviderName] = useState('');
    const [ErrServiceProviderName, setErrServiceProviderName] = useState('');
    const [address, setAddress] = useState('');
    const [ErrAddress, setErrAddress] = useState('');    
    const [contactPersonName, setContactPersonName] = useState('');
    const [ErrContactPersonName, setErrContactPersonName] = useState('');
    const [contactNumber, setContactNumber] = useState('');
    const [ErrContactNumber, setErrContactNumber] = useState('');
    const [mailId, setMailId] = useState('');
    const [ErrMailId, setErrMailId] = useState('');
    const [mobileNumber, setMobileNumber] = useState('');
    const [ErrMobileNumber, setErrMobileNumber] = useState('');
    const [serviceUnder, setServiceUnder] = useState('');
    const [ErrServiceUnder, setErrServiceUnder] = useState('');
    const [expectedReturnDate, setExpectedReturnDate] = useState('');
    const [ErrExpectedReturnDate, setErrExpectedReturnDate] = useState('');
    const [actualReturnDate, setActualReturnDate] = useState('');
    const [ErrActualReturnDate, setErrActualReturnDate] = useState('');
    const [invoiceNumber, setInvoiceNumber] = useState('');
    const [ErrInvoiceNumber, setErrInvoiceNumber] = useState('');
    const [invoiceAmount, setInvoiceAmount] = useState('');
    const [ErrInvoiceAmount, setErrInvoiceAmount] = useState('');
    const [invoiceDate, setInvoiceDate] = useState('');
    const [ErrInvoiceDate, setErrInvoiceDate] = useState('');
    const [receiptRemark, setReceiptRemark] = useState('');
    const [ErrReceiptRemark, setErrReceiptRemark] = useState('');
    const [receiptDate, setReceiptDate] = useState('');
    const [ErrReceiptDate, setErrReceiptDate] = useState('');
    const [recivedBy, setRecivedBy] = useState('');
    const [ErrRecivedBy, setErrRecivedBy] = useState('');
    const [employeeId, setEmployeeId] = useState('');
    const [ErrEmployeeId, setErrEmployeeId] = useState('');
    const [employeeName, setEmployeeName] = useState('');
    const [ErrEmployeeName, setErrEmployeeName] = useState('');
    // const [expectedReturnDate,setExpectedReturnDate] = useState('');
    const [extensionDate, setExtensionDate] = useState('')
    const [ErrExtensionDate, setErrExtensionDate] = useState('');
    const [extendedReturnDate, setExtendedReturnDate] = useState('')
    const [ErrExtendedReturnDate, setErrExtendedReturnDate] = useState('');
    const [extensionReason, setExtensionReason] = useState('')
    const [ErrExtensionReason, setErrExtensionReason] = useState('');
    const [extensionApprovedBy, setExtensionApprovedBy] = useState('')
    const [ErrExtensionApprovedBy, setErrExtensionApprovedBy] = useState('');
    const [remarks, setRemarks] = useState('')
    const [ErrRemarks, setErrRemarks] = useState('');
    const [movementReason,setMovementReason] = useState('');

    const useQuery = () => new URLSearchParams(useLocation().search);
    const query = useQuery();
    const Tag = query.get('tag'); 
    
    useEffect(() => {
        if(Tag!=='' && Tag!==null){
            getTagAssetInfo(Tag);
            //alert(Tag);
        }
        
    }, [])

    const getTagAssetInfo = function() {
        getTemproryTransferData(Tag).then(function(res){
            if(res?.data?.data) {
                let data = res.data.data;
                setAssetInfo({
                    "financials_classification": data?.financials_classification,
                    "invoice_date": data?.invoice_date,
                    "supplier_name": data?.supplier_name,
                    "invoice_no": data?.invoice_no
                });
                transferId = data?.id;
                setTag(tag);
                setServiceProviderName(data?.service_provider_name);
                setAddress(data?.address);
                setContactPersonName(data?.contact_person_name);
                setContactNumber(data?.contact_number);
                setMailId(data?.mail_id);
                setMobileNumber(data?.mobile_number);
                setServiceUnder(data?.service_under);
                setExpectedReturnDate(data?.expected_return_date);
                setActualReturnDate(data?.actual_return_date);
                setInvoiceNumber(data?.invoice_number);
                setInvoiceAmount(data?.invoice_amount);
                setInvoiceDate(data?.invoice_date);
                setReceiptRemark(data?.recipt_remark);
                setReceiptDate(data?.recipt_date);
                setRecivedBy(data?.recived_by);
                setTransferInitiatedBy(data?.initiated_by);
                setInitiationDate(data?.initiated_date);
                setTransferApprovedBy(data?.approved_by);
                setApprovalDate(data?.approved_date);
                setTransferType(data?.transfer_type);
                setEmployeeId(data?.employee_id);
                setEmployeeName(data?.employee_name);
                setExtensionDate(data?.date_of_extension);
                setExtendedReturnDate(data?.extended_date);
                setExtensionReason(data?.extension_reason);
                setExtensionApprovedBy(data?.extension_approved_by);
                setRemarks(data?.remarks);
            }
        })
    }

    const getTagInfo = function() {
        getTemproryTransferData(tag).then(function(res){
            if(res?.data?.data) {
                let data = res.data.data;
                setAssetInfo({
                    "financials_classification": data?.financials_classification,
                    "invoice_date": data?.invoice_date,
                    "supplier_name": data?.supplier_name,
                    "invoice_no": data?.invoice_no
                });
                transferId = data?.id;
                setTag(tag);
                setServiceProviderName(data?.service_provider_name);
                setAddress(data?.address);
                setContactPersonName(data?.contact_person_name);
                setContactNumber(data?.contact_number);
                setMailId(data?.mail_id);
                setMobileNumber(data?.mobile_number);
                setServiceUnder(data?.service_under);
                setExpectedReturnDate(data?.expected_return_date);
                setActualReturnDate(data?.actual_return_date);
                setInvoiceNumber(data?.invoice_number);
                setInvoiceAmount(data?.invoice_amount);
                setInvoiceDate(data?.invoice_date);
                setReceiptRemark(data?.recipt_remark);
                setReceiptDate(data?.recipt_date);
                setRecivedBy(data?.recived_by);
                setTransferInitiatedBy(data?.initiated_by);
                setInitiationDate(data?.initiated_date);
                setTransferApprovedBy(data?.approved_by);
                setApprovalDate(data?.approved_date);
                setTransferType(data?.transfer_type);
                setEmployeeId(data?.employee_id);
                setEmployeeName(data?.employee_name);
                setExtensionDate(data?.date_of_extension);
                setExtendedReturnDate(data?.extended_date);
                setExtensionReason(data?.extension_reason);
                setExtensionApprovedBy(data?.extension_approved_by);
                setRemarks(data?.remarks);
            }
        })
    }
    const handleSubmit = async (e) => {
        e.preventDefault();
        // if button enabled with JS hack
        //const v1 = TEXT_REGEX.test(division);
        if (!TEXT_REGEX.test(transferInitiatedBy)) {
            setErrTransferInitiatedBy('Transfer initiated by is required'); setValidName(false);
            //return;
        } else { setErrTransferInitiatedBy(''); }

        if (!TEXT_REGEX.test(initiationDate)) {
            setErrInitiationDate('Date of initiation is required'); setValidName(false);
            //return;
        } else { setErrInitiationDate(''); }

        if (!TEXT_REGEX.test(transferApprovedBy)) {
            setErrTransferApprovedBy('Transfer approved by is required'); setValidName(false);
            //return;
        } else { setErrTransferApprovedBy(''); }

        if (!TEXT_REGEX.test(approvalDate)) {
            setErrApprovalDate('Date of approval is required'); setValidName(false);
            //return;
        } else { setErrApprovalDate(''); }

        if (!TEXT_REGEX.test(transferType)) {
            setErrTransferType('Select type of transfer is required'); setValidName(false);
            //return;
        } else { setErrTransferType(''); }

        if (!TEXT_REGEX.test(serviceProviderName)) {
            setErrServiceProviderName('Service provider name is required'); setValidName(false);
            //return;
        } else { setErrServiceProviderName(''); }

        if (!TEXT_REGEX.test(address)) {
            setErrAddress('Address is required'); setValidName(false);
            //return;
        } else { setErrAddress(''); }

        if (!TEXT_REGEX.test(contactPersonName)) {
            setErrContactPersonName('Contact person name is required'); setValidName(false);
            //return;
        } else { setErrContactPersonName(''); }

        if (!TEXT_REGEX.test(contactNumber)) {
            setErrContactNumber('Contact number is required'); setValidName(false);
            //return;
        } else { setErrContactNumber(''); }

        if (!TEXT_REGEX.test(mailId)) {
            setErrMailId('MailId is required'); setValidName(false);
            //return;
        } else { setErrMailId(''); }

        if (!TEXT_REGEX.test(mobileNumber)) {
            setErrMobileNumber('Mobile number is required'); setValidName(false);
            //return;
        } else { setErrMobileNumber(''); }

        if (!TEXT_REGEX.test(serviceUnder)) {
            setErrServiceUnder('Select service under is required'); setValidName(false);
            //return;
        } else { setErrServiceUnder(''); }

        if (!TEXT_REGEX.test(expectedReturnDate)) {
            setErrExpectedReturnDate('Expected date of return is required'); setValidName(false);
            //return;
        } else { setErrExpectedReturnDate(''); }

               
        //alert(division);
        if (validName) {
            saveData(); //submit form
        } else {
            return false;
        }
    }

    const saveData = function() {
        var data = {
            "id":transferId,
            "tag":tag,
            "service_provider_name":serviceProviderName,
            "address":address,
            "contact_person_name":contactPersonName,
            "contact_number":contactNumber,
            "mail_id":mailId,
            "mobile_number":mobileNumber,
            "service_under":serviceUnder,
            "expected_return_date":expectedReturnDate?.dbFormatedDate(),
            "actual_return_date":actualReturnDate?.dbFormatedDate(),
            "invoice_number":invoiceNumber,
            "invoice_amount":invoiceAmount,
            "invoice_date":invoiceDate?.dbFormatedDate(),
            "recipt_remark":receiptRemark,
            "recipt_date":receiptDate?.dbFormatedDate(),
            "recived_by":recivedBy,
            "initiated_by":transferInitiatedBy,
            "initiated_date":initiationDate?.dbFormatedDate(),
            "approved_by":transferApprovedBy,
            "approved_date":approvalDate?.dbFormatedDate(),
            "transfer_type":transferType,
            "employee_id":employeeId,
            "employee_name":employeeName,
            "date_of_extension":extensionDate?.dbFormatedDate(),
            "extended_date":extendedReturnDate?.dbFormatedDate(),
            "extension_reason":extensionReason,
            "extension_approved_by":extensionApprovedBy,
            "remarks":remarks
        }
        saveTemproryTransferData(data).then(function(res) {
            //console.log(res);
        })
    }
    return (
        <div className="container">
            <div className="row">
                <div className="col">
                    <h5>Send Repair</h5>
                </div>
            </div>
            <div className='row'>
                <div className='col'><h5 className='align-right'>TAG </h5></div>
                <div className='col'><input onChange={function(event){setTag(event.target.value)}} type="text" className="form-control"  placeholder='Enter the asset TAG'/></div>
                <div className='col'><button onClick={getTagInfo} className='btn btn-primary'> Search </button></div>
            </div>
            <div className="row">
                <div className="col-6">
                    <FromFieldLabel  
                        label="Financial Classification" 
                        inputValue={assetInfo.financials_classification}
                        /> 
                </div>
                <div className="col-6">
                    <FromFieldLabel
                        label="Invoice Date" 
                        inputValue={getFormatedDate(assetInfo.invoice_date)}
                        /> 
                </div>
            </div>
            <div className="row border-bottom">
                <div className="col-6">
                    <FromFieldLabel  
                        label="Supplier Name" 
                        inputValue={assetInfo.supplier_name}
                        /> 
                </div>
                <div className="col-6">
                    <FromFieldLabel
                        label="Supplier Invoice No" 
                        inputValue={assetInfo.invoice_no} 
                        /> 
                </div>
            </div>
            <form onSubmit={handleSubmit} >
            <div className="row">
                <div className="col-6">
                    <FromFieldText  star='*'
                        label="a. Transfer Initiated By" 
                        placeholder="Transfer Initiated By" 
                        inputValue={transferInitiatedBy}
                        setInputValue={setTransferInitiatedBy}
                        setErrorMsg={ErrTransferInitiatedBy}

                        /> 
                </div>
                <div className="col-6">
                    <FromFieldDate star='*'
                        label="Date of Initiation" 
                        inputValue={initiationDate}
                        setInputValue={setInitiationDate}
                        setErrorMsg={ErrInitiationDate}
                        /> 
                </div>
            </div>

            <div className="row">
                <div className="col-6">
                    <FromFieldText star='*'
                        label="a. Transfer Approved By" 
                        placeholder="Transfer Approved By" 
                        inputValue={transferApprovedBy}
                        setInputValue={setTransferApprovedBy}
                        setErrorMsg={ErrTransferApprovedBy}
                        /> 
                </div>
                <div className="col-6">
                    <FromFieldDate star='*'
                        label="Date of Approval" 
                        inputValue={approvalDate}
                        setInputValue={setApprovalDate}
                        setErrorMsg={ErrApprovalDate}
                        /> 
                </div>
            </div>

            <div className="row bottom-border">
                <div className="col-6">
                    <FromFieldSelect star='*'
                    label="a. Type of Transfer"
                    placeholder="Select Type of Transfer"
                    selectedValue={transferType}
                    setSelectedValue={setTransferType}
                    values={["Repair", "Testing"]}
                    setErrorMsg={ErrTransferType}
                />
                </div>
                <div className="col-6">
                    
                </div>
            </div>

            <div className="row">
                <div className="col-6">
                    <FromFieldText star='*'
                        label="i. Service Provider Name" 
                        placeholder="Service Provider Name" 
                        inputValue={serviceProviderName}
                        setInputValue={setServiceProviderName}
                        setErrorMsg={ErrServiceProviderName}
                        /> 
                </div>
                <div className="col-6">
                    <FromFieldText star='*'
                        label="ii. Address" 
                        placeholder="Address" 
                        inputValue={address}
                        setInputValue={setAddress}
                        setErrorMsg={ErrAddress}
                        />
                </div>
            </div>

            <div className="row">
                <div className="col-6">
                    <FromFieldText star='*'
                        label="iii. Contact Person Name" 
                        placeholder="Contact Person Name" 
                        inputValue={contactPersonName}
                        setInputValue={setContactPersonName}
                        setErrorMsg={ErrContactPersonName}
                        /> 
                </div>
                <div className="col-6">
                    <FromFieldText star='*'
                        label="iv. Contact Number" 
                        placeholder="Contact Number" 
                        inputValue={contactNumber}
                        setInputValue={setContactNumber}
                        setErrorMsg={ErrContactNumber}
                        /> 
                </div>
            </div>

            <div className="row">
                <div className="col-6">
                    <FromFieldText star='*'
                        label="v. Mail Id" 
                        placeholder="Mail Id" 
                        inputValue={mailId}
                        setInputValue={setMailId}
                        setErrorMsg={ErrMailId}
                        /> 
                </div>
                <div className="col-6">
                    <FromFieldText star='*'
                        label="vi. Mobile Number" 
                        placeholder="Mobile Number" 
                        inputValue={mobileNumber}
                        setInputValue={setMobileNumber}
                        setErrorMsg={ErrMobileNumber}
                        /> 
                </div>
            </div>

            <div className="row bottom-border">
                <div className="col-6">
                    <FromFieldSelect star='*'
                        label="vii. Service Under"
                        placeholder="Select Service Under"
                        selectedValue={serviceUnder}
                        setSelectedValue={setServiceUnder}
                        values={["Waranty", "AMC Coverage", "Insurance Coverage", "Out of Pocket", "Not Applicable", "Free Of Cost"]}
                        setErrorMsg={ErrServiceUnder}
                    />
                </div>
                <div className="col-6">
                    <FromFieldDate star='*'
                        label="vii Expected Date Of Return" 
                        inputValue={expectedReturnDate}
                        setInputValue={setExpectedReturnDate}
                        setErrorMsg={ErrExpectedReturnDate}
                        />
                </div>
            </div>


            <div className="row">
                <div className="col-6"></div>
                <div className="col-6"><button onClick={saveData} className='btn btn-primary'> SAVE </button></div>
                </div>
                </form>
        </div>
    )
}

export default TemproryTransfer